<!--
 * @Author: zerui.yao
 * @Date: 2022-11-28 10:52:12
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-18 16:29:50
 * @FilePath: /fed-authority/src/layouts/HeaderAsideLayout/components/tools/UserMenu.vue
 * @Description: 
-->
<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <a href="#/help"
        target="_blank">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon>
        </span>
      </a> -->
      <!-- <feed-back v-if="showFeedBack" class="action" /> -->
      <avatar-dropdown :menu="true" class="action" :current-user="currentUser" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { goSSO } from '@/utils';
import auth from '@/utils/auth';
// import FeedBack from './FeedBack.vue';
import AvatarDropdown from './AvatarDropdown.vue';

export default {
  name: 'UserMenu',
  components: {
    // FeedBack,
    AvatarDropdown,
  },
  props: {
    primaryColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('system/user', ['userName', 'name', 'avatar']),
    ...mapState('system/app', ['showChangeColor', 'showChangeLanguage', 'showTips']),
    currentUser() {
      return {
        name: this.name,
        avatar: this.avatar,
      };
    },
    showFeedBack() {
      // return ['ecarx.com.cn', 'ecarxgroup.com', '127.0.0.1'].filter(url => window.location.hostname.indexOf(url) > -1).length > 0;
      return true;
    },
  },
  data() {
    return {};
  },

  methods: {
    ...mapActions('system/user', ['Logout']),
    handleLogout() {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () =>
          this.Logout({})
            .then((success) => {
              if (success) {
                auth.logout();
                goSSO();
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            }),
        onCancel() {},
      });
    },
    changeColor(color) {
      this.$emit('changeColor', color);
    },
  },
};
</script>
